import {Injectable} from '@angular/core';
import {TrustiiService} from './trustii.service';
import {SessionService} from './session.service';
import {DialogService} from 'src/app/services/dialog.service';
import {DataService} from './data.service';

export enum FileType {
  TRAINING = 'training',
  LIVE = 'live',
  MODEL = 'MODEL'
}

export enum AutoMLStatus {
  IN_PROGRESS = 'in-progress',
  SUCCESS = 'done',
  FAIL = 'error'
}


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  uploadResponse = {status: '', message: '', filePath: ''};

  constructor(private trustiiService: TrustiiService, private dataService: DataService, private dialogService: DialogService,
              private sessionService: SessionService) {
  }

  upload(type: FileType, name: string, size: number, data) {
    const id = Date.now();
    this.dataService.enterpriseDatasetUploadQueue.push({value: 0, fileName: name, size, id, uploadRequest: null, uploaded: 0});
    let autoLoginTimeout = null;

    const requestObject = this.trustiiService.upload(data, type).subscribe(
      (res) => {
        this.uploadResponse = res;
        if (res.status === 'progress') {
          this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).value = res.message;
          this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).uploaded = res.uploaded;
          this.dataService.fileUploadProgressSubject.next(this.dataService.enterpriseDatasetUploadQueue);
          if (!autoLoginTimeout) {
            autoLoginTimeout = setTimeout(() => {
              this.trustiiService.autoLogin().subscribe(autores => {
                // do nothing; its just to ping and keep session alive
                autoLoginTimeout = null;
              }, autoerr => {
                autoLoginTimeout = null;
              });
            }, 30 * 1000); // ping every 30 seconds
          }
        } else if (res.status === 'error') {
          this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).value = 0;
          this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).uploaded = 0;
          this.dataService.fileUploadProgressSubject.next(this.dataService.enterpriseDatasetUploadQueue);
          this.dialogService.openAlertDialog(
            '350px',
            'Error uploading file: ' + name,
            'ERROR',
            'Ok',
            'modal-warning'
          );
        } else if (res.data) {
          this.getDataSet(res.data.id, id);
          this.sessionService.refreshUser();
        }
      },
      (err) => {
        this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).value = 0;
        this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).uploaded = 0;
        this.dataService.fileUploadProgressSubject.next(this.dataService.enterpriseDatasetUploadQueue);
        this.dialogService.openAlertDialog(
          '350px',
          'Error uploading file: ' + name,
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
    this.dataService.enterpriseDatasetUploadQueue.find(item => item.id === id).uploadRequest = requestObject;
  }

  getDataSet(datasetId, queueId) {
    this.trustiiService.getDataset(datasetId).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getDataSet(datasetId, queueId);
          }, 3 * 1000); // poll every 3 seconds
        } else {
          this.dataService.enterpriseDatasetUploadQueue = this.dataService.enterpriseDatasetUploadQueue.filter(item => item.id !== queueId);
          this.dataService.enterpriseFileUploadSubject.next();
        }
      },
      (err) => {
        this.dataService.enterpriseDatasetUploadQueue = this.dataService.enterpriseDatasetUploadQueue.filter(item => item.id !== queueId);
        this.dataService.enterpriseFileUploadSubject.next({});
      }
    );
  }

}

@Injectable({
  providedIn: 'root'
})
export class AutoMLGenerateService {
  constructor(private trustiiService: TrustiiService, private dataService: DataService,
              private sessionService: SessionService) {
  }

  generate(datasetId: number, datasetName: string) {
    this.dataService.enterpriseModelGenerateQueue = this.dataService.enterpriseModelGenerateQueue.filter(
      item => item.datasetId !== datasetId
    );
    this.dataService.enterpriseModelGenerateQueue.push({datasetId, status: AutoMLStatus.IN_PROGRESS});
    this.trustiiService.buildMLModel(datasetId).subscribe(res => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getMlModel(res.data.id, datasetId, datasetName);
          }, 10 * 1000); // poll every 10 seconds
        } else {
          this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).error = res.data.error;
          this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).status = res.data.status;
          this.dataService.enterpriseModelGenerateSubject.next();
          this.sessionService.refreshUser();
        }
      },
      (err) => {
        this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).status = AutoMLStatus.FAIL;
      });
  }

  getMlModel(modelId, datasetId, datasetName) {
    this.trustiiService.getMLModel(modelId).subscribe(res => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getMlModel(modelId, datasetId, datasetName);
          }, 10 * 1000); // poll every 10 seconds
        } else {
          this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).status = res.data.status;
          this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).error = res.data.error;
          this.dataService.enterpriseModelGenerateSubject.next();
        }
      },
      (err) => {
        this.dataService.enterpriseModelGenerateQueue.find(item => item.datasetId === datasetId).status = AutoMLStatus.FAIL;
      });
  }

}
